import { Button } from '@mui/material'
import React, { useEffect } from 'react'
import { type DisbursementBatchDetails } from '../../../../api-schema-types/payments/DisbursementBatchDomainDtos'
import { useUnlinkDisbursementInstructionsMutation } from '../../../../api-services/payments/paymentsApi'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'
import { setNotification } from '../../../components/ui-widgets/uiWidgetsSlice'
import { setUnlinkActions } from './disbursementsSlice'

interface UnlinkInstructionsProps {
  disbursementBatch: DisbursementBatchDetails
  disbursementInstructionIds: number[]
}
const UnlinkInstructions: React.FC<UnlinkInstructionsProps> = ({ disbursementBatch, disbursementInstructionIds }: UnlinkInstructionsProps) => {
  const dispatch = useAppDispatch()

  const [apiUnlinkInstructionsTrigger, apiUnlinkInstructionsResult] = useUnlinkDisbursementInstructionsMutation()
  const handleUnlinkInstructions = async (): Promise<void> => {
    const choice = window.confirm(
      'Are you sure you want to unlink instructions from this batch?'
    )
    if (choice) {
      await apiUnlinkInstructionsTrigger({ disbursementBatchId: disbursementBatch.disbursementBatchId, disbursementInstructionIds })
    }
  }

  useEffect(() => {
    if (apiUnlinkInstructionsResult.isSuccess) {
      dispatch(setNotification({
        open: true,
        severity: 'success',
        message: `${disbursementInstructionIds.length} instructions unlinked from disbursement batch ${apiUnlinkInstructionsResult.data.disbursementBatchId} cancelled.`
      }))
      dispatch(setUnlinkActions([]))
    }

    if (apiUnlinkInstructionsResult.isError) {
      dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(apiUnlinkInstructionsResult.error) }))
    }
  }, [apiUnlinkInstructionsResult.isSuccess, apiUnlinkInstructionsResult.isError])

  return (
    <>
      <Button type={'button'} variant={'contained'} color={'warning'}
              sx={{ mr: 2 }}
              disabled={!(disbursementBatch.canUnlinkInstructions && disbursementInstructionIds.length > 0)}
              onClick={handleUnlinkInstructions}>
        Unlink Selected Instructions
      </Button>
    </>
  )
}

export default UnlinkInstructions
